<la-error-state-card [title]="title" [body]="body" [showGoToMaps]="true" (goToMaps)="navigateToMaps()"></la-error-state-card>
